import { render, staticRenderFns } from "./HousesModuleComponent.vue?vue&type=template&id=e93a349a&scoped=true&"
import script from "./HousesModuleComponent.vue?vue&type=script&lang=js&"
export * from "./HousesModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./HousesModuleComponent.vue?vue&type=style&index=0&id=e93a349a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93a349a",
  null
  
)

export default component.exports